export default class MobileSearchBehavior {
    constructor(context) {
        this.context = context;

        this.initMobileSearch();
    }

    initMobileSearch() {
        const $search = this.context.querySelector('input[name="search"]');

        if ($search) {
            $search.addEventListener('focus', (e) => this.eventHandling(e), false);
            $search.addEventListener('blur', (e) => this.eventHandling(e), false);
        }
    }

    eventHandling(e) {
        this.context.classList.toggle('is-search-focused', e.type === 'focus');
    }
}
